module.exports = __webpack_public_path__ + "static/media/expert_profile_icon.58f19aa3.svg";